import apiCreator from './util/ApiCreator';
const api = apiCreator('/api-public/dealer-portal/dealer');

export default {
    login (data) {
        return api.post('/login', data);
    },
    signup (data) {
        return api.post('/signup', data);
    },
    postForgotPassword (data) {
        return api.post('/forgot-password', data);
    },
    getValidatePasswordResetToken (userId, token) {
        return api.get(`/password-reset-validate/${userId}/${token}`)
    },
    postPasswordReset (userId, token, data) {
        return api.post(`/password-reset/${userId}/${token}`, data);
    }
}
